import * as actions from './actionTypes'

export function toggleLink(selectedLink) {
  return {
    type: actions.TOGGLE_LINK,
    payload: { selectedLink },
  }
}
